import Shepherd from 'shepherd.js';
if($('.network-administration-reporting').length && !$('#performance-overview').length && !$('#dashboard-reporting').length){

    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'network-administration-reporting'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));

    var dataType = $('.network-administration-reporting').attr('data-type');
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: dataType+' Administration',
        text: "Welcome to your "+dataType+" administration area. On this page, you will find reporting on how your "+dataType+" is performing. This is also your portal for the administration for the rest of your "+dataType+".",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Navigating your admin area',
        text: "Using this navigation bar, you can quickly access other areas of administration, including the list of your applications and a link to download your Network PDF (if its included in your package), as well as quick links to view and edit your "+dataType+".",
        attachTo: {
            element: '#network-administration-nav',
            on: 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: "Changing your reporting dates",
        text: "By default your reporting analytics and statistics will only show the previous 30 days of data. Using the two date selectors, you can easily change the time period to be whatever you wish.",
        attachTo: {
            element: '#date-selectors',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-3'
    });
    
    tour.addStep({
        title: "Export your reporting data",
        text: "You can export all of the single value statistics (excluding the charts), in CSV format for the date range you currently have selected. To do this simply click this button.",
        attachTo: {
            element: '#download-reporting',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    });
    
    tour.addStep({
        title: "What next?",
        text: "Once you've had a chance to look around this page and you've recieved your first application, click on the eye icon displayed on each application row on the table, or on an application card in grid view, to go and have a look at the full application.",
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-5'
    });

    $('.replay-onboarding').show();
    
    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if(!$('.onboarding-network-administration-reporting').length){
        tour.start();
    }
}
